import { Controller } from "stimulus";
import React from "react";
import ReactDOM from "react-dom";
import Slider from "react-slick";


import { windowLoad } from "./../utils";

export default class extends Controller {
    static targets = ["list", "item", "left", "right"];

    connect() {
        this.sliderRef = React.createRef();
        if (!this.hasItemTarget) return;
        windowLoad(this.init);
    }

    disconnect() {
        if (this.leftTarget)  this.leftTarget.removeEventListener("click", this._boundPrev);
        if (this.rightTarget) this.rightTarget.removeEventListener("click", this._boundNext);

        if (this.hasListTarget) {
            ReactDOM.unmountComponentAtNode(this.listTarget);
        }
    }

    handlePrev = () => {
        if (this.sliderRef.current) {
            this.sliderRef.current.slickPrev();
        }
    };

    handleNext = () => {
        if (this.sliderRef.current) {
            this.sliderRef.current.slickNext();
        }
    };

    init = () => {
        if (this._mounted) return;
        this.length = this.itemTargets.length;

        const slidesToShow = parseFloat(this.data.get("slidesToShow")) || 4.5;

        const slides = this.itemTargets.map((node, i) => (
            <div key={i} dangerouslySetInnerHTML={{ __html: node.innerHTML }} />
        ));
        if (this.leftTarget) {
            this.leftTarget.addEventListener('click', this.handlePrev);
        }
        if (this.rightTarget) {
            this.rightTarget.addEventListener('click', this.handleNext);
        }

        const settings = {
            infinite: false,
            arrows: false,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 821,
                    settings: {
                        slidesToShow: Math.min(2, this.length),
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 601,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        };

        ReactDOM.render(<Slider {...settings}  className="vehicle-card-slider"
                                ref={this.sliderRef}>{slides}</Slider>, this.listTarget);
        this._mounted = true;
    };
}
